// extracted by mini-css-extract-plugin
export default {"container":"ProjectsList_container__qY18E","title":"ProjectsList_title__j8Yqz"};